import NavMenuItem from './NavMenuItem.vue';

export default NavMenuItem;
